/** @format */

import moment from 'moment';
import { ItemLoaders } from './loaders/ItemLoaders';
import { Auth } from '../modules/auth/Auth';
import { configDefault } from './config';
import { FormGeneralHelper } from '../helpers/FormGeneral';
import { history } from './history';

export class RefreshToken {
    private itemLoader: ItemLoaders;

    private refreshTokenInProgress = false;

    public lastUpdateTime = 0;

    constructor(itemLoader: ItemLoaders) {
        this.itemLoader = itemLoader;
        this.lastUpdateTime = Auth.getSessionStartTime() + Auth.getSessionValidTime();
    }

    checkLastTick = (): void => {
        if (!this.refreshTokenInProgress && this.lastUpdateTime < moment().unix()) {
            this.deleteToken();
            Auth.clearToken();
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            history.push('/admin/login');
            return;
        }
        this.checkToken('checkIdleTime');
    };

    checkToken = (requestUri: string | null): void => {
        const localTime = moment().unix();
        const tokenTime = Auth.getSessionExpirationTime() - configDefault.REFRESH_TOKEN_TIME_REQUEST_SECOND;
        if (tokenTime < localTime && !this.refreshTokenInProgress) {
            this.refreshToken();
        }
        if (requestUri !== 'checkIdleTime') {
            this.lastUpdateTime = localTime + Auth.getSessionValidTime();
        }
    };

    refreshToken = (): void => {
        if (!Auth.getAccessToken()) {
            return;
        }
        this.refreshTokenInProgress = true;
        this.itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/refresh_tokens', configDefault.PLATFORM_API_PREFIX)),
            'refresh_token_post',
            {},
            (data: any): void => {
                if (data && data.token) {
                    Auth.storeToken(data.token);
                }
                this.refreshTokenInProgress = false;
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false },
            { disableDefaultNotification: true }
        );
    };

    deleteToken = (): void => {
        this.itemLoader.deleteCall(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/refresh_tokens/1', configDefault.PLATFORM_API_PREFIX)),
            'refresh_token_delete',
            (data: any): void => {}
        );
    };
}
